import React from "react";
import style from "./Servicios.module.css";
import serv1 from "../../../../Assets/img/serv1.png";

import serv2 from "../../../../Assets/img/serv2.png";
import { useMediaQuery } from "@material-ui/core";

export const Servicios = () => {
  const mobile = useMediaQuery("(max-width:768px)");
  return (
    <div
      id="Servicios"
      className={!mobile ? style.container : style.containerMob}
    >
      <div className={!mobile ? style.item1 : style.item1Mob}>
        <div className={!mobile ? style.txtcont : style.txtcontMob}>
          <h1 className={!mobile ? style.title : style.titleMob}>
            {" "}
            ¿Por qué Visnú?{" "}
          </h1>

          <p className={!mobile ? style.text : style.textMob}>
            Visnú (origen Hindú) "el preservador en la modalidad de la bondad",
            quien habita en el paraíso, posee conocimiento, energía y fuerza.
            Quien tiene varios avatares para actuar como “el conservador y
            protector” cuando el mundo se halle amenazado por el mal, el caos y
            las fuerzas destructivas. Cuenta la historia que en algún momento
            los demonios robaron el néctar de la inmortalidad a los dioses,
            entonces Visnú adoptó la forma de una mujer para acercarse a los
            demonios, quienes quedaron deslumbrados con su belleza. De esta
            manera Visnú recuperó el néctar y lo devolvió a los dioses. La
            historia nos recuerda cuando hemos tenido que buscar estrategias en
            nuestra vida y transformarnos sin perder nuestra esencia con el fin
            de hacer un bien.
          </p>
        </div>
      </div>

      <div className={!mobile ? style.item2 : style.item2Mob}>
        <div className={!mobile ? style.imgcont : style.imgcontMob}>
          <img
            className={!mobile ? style.img : style.imgMob}
            src={serv1}
            alt=""
          />
          <img
            className={!mobile ? style.img2 : style.img2Mob}
            src={serv2}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};
